import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export function Breadcrumbs({ items = [] }) {
  return (
    <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="mb-5">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-slate-500">
        <li>
          <Link to="/" className="flex items-center gap-1 hover:text-[#ff4500]">
            <Home size={14} /> Home
          </Link>
        </li>
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1">
            <ChevronRight size={14} className="text-slate-300" />
            {it.to && i < items.length - 1 ? (
              <Link to={it.to} className="hover:text-[#ff4500]">
                {it.label}
              </Link>
            ) : (
              <span className="text-slate-900 font-medium">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
